import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";

const Main = lazy(() => import("../../components/activities/allActivities/main"));

const Activities = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default Activities;

